var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "md-column" } },
    [
      _vm.loadingComponent
        ? _c("loader", { attrs: { loading: _vm.loadingComponent, size: 45 } })
        : _c(
            "md-theme",
            { attrs: { "md-name": "blue" } },
            [
              _c("breadcrumbs", {
                attrs: {
                  id: "scrollToError",
                  section: "Licenses",
                  nav: _vm.nav
                }
              }),
              _c(
                "md-layout",
                { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("metadata-form", {
                            attrs: {
                              title: "License",
                              entity: _vm.license,
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v.license
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "md-headline",
                              attrs: { id: "geo-title" }
                            },
                            [_vm._v("Geographic Rules")]
                          ),
                          _c("div", { staticClass: "md-subheading" }, [
                            _vm._v("Approach")
                          ]),
                          _c(
                            "md-radio",
                            {
                              staticClass: "md-primary",
                              attrs: { "md-value": "allow" },
                              model: {
                                value: _vm.license.geoList.mode,
                                callback: function($$v) {
                                  _vm.$set(_vm.license.geoList, "mode", $$v)
                                },
                                expression: "license.geoList.mode"
                              }
                            },
                            [_vm._v("Allow")]
                          ),
                          _c(
                            "md-radio",
                            {
                              staticClass: "md-primary",
                              attrs: { "md-value": "deny" },
                              model: {
                                value: _vm.license.geoList.mode,
                                callback: function($$v) {
                                  _vm.$set(_vm.license.geoList, "mode", $$v)
                                },
                                expression: "license.geoList.mode"
                              }
                            },
                            [_vm._v("Deny")]
                          ),
                          _c("country-selector", {
                            model: {
                              value: _vm.license.geoList.countries,
                              callback: function($$v) {
                                _vm.$set(_vm.license.geoList, "countries", $$v)
                              },
                              expression: "license.geoList.countries"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("domains-form", {
                            attrs: { entity: _vm.license },
                            on: {
                              created: function($event) {
                                return _vm.showAlertToast($event, "success")
                              },
                              error: function($event) {
                                return _vm.showAlertToast($event, "error")
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("platforms-form", {
                            attrs: { entity: _vm.license }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "50", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "md-headline",
                              attrs: { id: "window-title" }
                            },
                            [_vm._v("Licensing Window")]
                          ),
                          _c("status-radio", {
                            model: {
                              value: _vm.license.status,
                              callback: function($$v) {
                                _vm.$set(_vm.license, "status", $$v)
                              },
                              expression: "license.status"
                            }
                          }),
                          _c("date-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.license.status !== "draft" ? true : false,
                                expression:
                                  "license.status !== 'draft' ? true : false"
                              }
                            ],
                            attrs: {
                              validation: _vm.$v.license.startDate,
                              formSubmitted: _vm.formSubmitted,
                              label: "Available from"
                            },
                            model: {
                              value: _vm.license.startDate,
                              callback: function($$v) {
                                _vm.$set(_vm.license, "startDate", $$v)
                              },
                              expression: "license.startDate"
                            }
                          }),
                          _c("date-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.license.status !== "draft" ? true : false,
                                expression:
                                  "license.status !== 'draft' ? true : false"
                              }
                            ],
                            attrs: {
                              validation: _vm.$v.license.endDate,
                              formSubmitted: _vm.formSubmitted,
                              label: "Available until"
                            },
                            model: {
                              value: _vm.license.endDate,
                              callback: function($$v) {
                                _vm.$set(_vm.license, "endDate", $$v)
                              },
                              expression: "license.endDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("pricing-form", { attrs: { entity: _vm.license } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    { attrs: { "md-align": "center" } },
                    [
                      _c("stitch-loader", {
                        attrs: { loading: _vm.creatingOrUpdating, size: 40 }
                      }),
                      _c(
                        "md-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.creatingOrUpdating,
                              expression: "!creatingOrUpdating"
                            }
                          ],
                          staticClass: "md-raised md-primary",
                          attrs: {
                            id: "submit-btn",
                            disabled: _vm.$v.$pending,
                            "md-theme": "blue"
                          },
                          on: { click: _vm.onFormSubmit }
                        },
                        [_vm._v(_vm._s(_vm.editMode ? "Update" : "Create"))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8425f1fa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8425f1fa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/license/LicenseForm.vue
// module id = 869
// module chunks = 0